import { palette } from '../../../settings/themes/colors';

const styles = () => ({
  actions_centered: {
    justifyContent: 'center'
  },
  detailsLabel: {
    display: 'block',
    fontWeight: 700,
    color: palette.darkGray
  }
});

export default styles;
